import { createElement, FC } from 'react'
import { Navigate, RouteObject } from 'react-router-dom'
import { authStore } from '@/store/authStore'
import { papelPrincipal } from '@/components/layout/menu'

/**
 * Mapa rota antiga → rota nova (Onda 1 / A02). Regra de ouro: NENHUM link antigo
 * quebra — todo caminho antigo redireciona com `<Navigate replace>` para o nome
 * novo do Figma. Quando a página nova ainda não existe, a rota nova renderiza a
 * página antiga (ver `rotas/a02.tsx`): renomeamos a ROTA, não a página.
 *
 * Arquivo de DADO + fábrica de RouteObject, sem JSX, para o teste de redirect
 * montar exatamente o que vai ao router de produção.
 */
export interface Redirect {
  de: string
  para: string
}

export const REDIRECTS: readonly Redirect[] = [
  { de: '/kanban', para: '/pipeline' },
  { de: '/operacoes', para: '/operacoes-clientes' },
  { de: '/clientes', para: '/operacoes-clientes?aba=clientes' },
  { de: '/pendencias', para: '/pendencias-documentos' },
  { de: '/documentos', para: '/pendencias-documentos?aba=documentos' },
  { de: '/produtos', para: '/produtos-materiais' },
  { de: '/seguranca', para: '/usuarios/meu-acesso?aba=seguranca' },
  { de: '/perfil', para: '/usuarios/meu-acesso?aba=perfil' },
  { de: '/lgpd/meus-dados', para: '/meus-dados' },
  { de: '/lgpd/incidente', para: '/reportar-incidente' },
  { de: '/candidaturas', para: '/usuarios-acessos?aba=candidaturas' },
  { de: '/tenants', para: '/usuarios-acessos?aba=tenants' },
  { de: '/usuarios/saneamento-operador', para: '/usuarios-acessos?aba=saneamento-operador' },
  { de: '/conteudo-primeiro-acesso', para: '/usuarios-acessos?aba=conteudo-primeiro-acesso' },
  { de: '/usuarios', para: '/usuarios-acessos' },
  { de: '/agenda/pendentes', para: '/agenda?aba=pendentes' },
  { de: '/agendamentos-pendentes', para: '/agenda?aba=pendentes' },
  { de: '/simulacao', para: '/simulacoes' },
]

/** Destino de /renovacoes depende da persona: consultor acompanha as suas em
 *  Minhas Reservas; o back-office decide na fila de Reservas e Curadoria. */
export const destinoRenovacoes = (permissoes: string[] | undefined | null): string => {
  const papel = papelPrincipal(permissoes)
  const backoffice = papel === 'ADMIN' || papel === 'GERENTE' || papel === 'OPERADOR'
  return backoffice ? '/reservas-curadoria?aba=renovacoes' : '/reservas?aba=renovacoes'
}

const RedirectRenovacoes: FC = () => {
  const usuario = authStore((s) => s.usuario)
  return createElement(Navigate, { to: destinoRenovacoes(usuario?.permissoes), replace: true })
}

/** RouteObjects de redirect — concatenados ao router em `rotas/a02.tsx`. */
export const rotasDeRedirect = (): RouteObject[] => [
  ...REDIRECTS.map(({ de, para }) => ({
    path: de.replace(/^\//, ''),
    element: createElement(Navigate, { to: para, replace: true }),
  })),
  { path: 'renovacoes', element: createElement(RedirectRenovacoes) },
]
